import React, { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

const PermissionDeniedPage: React.FC = () => {
  useEffect(() => {
    // Set document title to indicate 403 status
    document.title = '403 - Permission Denied';
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-nova-color">
      <div className="text-center px-4 py-8 max-w-md">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-red-100 p-4">
            <AlertTriangle className="w-12 h-12 text-red-600" />
          </div>
        </div>
        
        <h1 className="text-4xl font-bold mb-2 font-family-messina-modern">
          403
        </h1>
        
        <h2 className="text-2xl font-semibold mb-4 font-family-messina-modern text-gray-800">
          Permission Denied
        </h2>
        
        <p className="text-gray-600 mb-6 font-family-messina-sans">
          You don't have permission to access this page now.
        </p>
      </div>
    </div>
  );
};

export default PermissionDeniedPage;

